export const GLOBAL_WIDGET_CONFIG_LABEL_KEY = 'WIDGET_CONFIG_LABEL';

// "default" label is not renameable
export const WIDGET_CONFIG_LABEL_DEFAULT = 'default';
